import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  orderText: {
    opacity: "27%",
  },
}))

export default styles
